// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  width: 100%;
  min-height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(1, 1, 1, 0.5);
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.loading-container .content-message {
  margin-top: 20px;
  font-weight: 500;
}
.loading-container [uk-spinner] {
  stroke: whitesmoke !important;
  color: antiquewhite !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/loading.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AACA;EACI,gBAAA;EACA,gBAAA;AACJ;AAEA;EACI,6BAAA;EACA,8BAAA;AAAJ","sourcesContent":[".loading-container {\n    width: 100%;\n    min-height: 100%;\n    position: fixed;\n    z-index: 9999;\n    background-color: rgba(1, 1, 1, 0.5);\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n.loading-container .content-message {\n    margin-top: 20px;\n    font-weight: 500;\n}\n\n.loading-container [uk-spinner] {\n    stroke: whitesmoke !important;\n    color: antiquewhite !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
